import { render, staticRenderFns } from "./FortnoxInvoiceMissingList.vue?vue&type=template&id=6b33e540"
import script from "./FortnoxInvoiceMissingList.vue?vue&type=script&lang=ts"
export * from "./FortnoxInvoiceMissingList.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports